import React from "react";

import { useTranslation } from "react-i18next";

import { useFieldArray, useFormContext } from "react-hook-form";

import AddButton from "@components/buttons/AddButton";

import InputAdvantageTitle from "../../modals/ModalSalaryForm/subComponents/InputAdvantageTitle";
import InputAnnualAdvantage from "../../modals/ModalSalaryForm/subComponents/InputAnnualAdvantage";
import TextAreaNote from "../../modals/ModalSalaryForm/subComponents/TextAreaNote";

/**
 *
 * @param {Object} props
 * @param {boolean} props.readOnly
 * @param {any[]} props.deviseList
 * @param {(...args: any) => void} props.handleError
 * @returns
 */
export default function AdvantageList(props) {
  const { t: translate } = useTranslation(
    "pages.employés.parcours&Certifications"
  );

  const { control, handleSubmit } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control,
    name: "AdvantageType"
  });

  function addAdvantage() {
    if (props.readOnly) return;

    const emptyAdvantage = {
      _id: "",
      name: "",
      annualValue: "",
      annualDevise: props.deviseList[0] || {},
      note: ""
    };

    if (fields.length === 0) {
      append(emptyAdvantage);
      return;
    }

    append(emptyAdvantage);
  }

  function removeAdvantage(index) {
    remove(index);
  }

  return (
    <>
      {!props.readOnly && (
        <div className="arh-mb-4 arh-mt-6 arh-flex arh-justify-start">
          <AddButton
            label={translate("Ajouter un avantage")}
            onClick={handleSubmit(addAdvantage, props.handleError)}
            color="arh-bg-greenColor hover:arh-bg-darkGreenColor"
            btnSize="arh-w-[30px] arh-h-[30px]"
            iconPosition="left"
            labelClass="arh-text-xs arh-font-medium !arh-text-darkColor"
          />
        </div>
      )}

      {fields?.length > 0 && (
        <div className="arh-mb-12 arh-grid arh-grid-cols-3 arh-gap-6">
          {fields.map((field, index) => (
            <div
              key={field.id}
              className="arh-flex arh-flex-col arh-gap-3"
            >
              <div className="arh-relative">
                <InputAdvantageTitle
                  readOnly={props.readOnly}
                  index={index}
                />

                <InputAnnualAdvantage
                  readOnly={props.readOnly}
                  index={index}
                  deviseList={props.deviseList}
                />

                <TextAreaNote
                  readOnly={props.readOnly}
                  classTextarea="arh-h-[6.563rem] arh-resize-none"
                  index={index}
                />

                {!props.readOnly && (
                  <div className="arh-flex arh-items-center arh-justify-between">
                    <div
                      className="cursor-pointer arh-mb-7 arh-flex arh-items-center arh-space-x-2 arh-font-poppins arh-text-[11px] arh-text-greenColor hover:arh-text-darkGreenColor"
                      onClick={() => removeAdvantage(index)}
                    >
                      {translate("Effacer")}
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
}
